import { Widget } from "@foretagsplatsen/widgetjs";
import optionsBag from "../../models/options/optionsBag.js";
import ReportDisclaimer from "../../models/ReportDisclaimer.js";

/**
 * Render a report disclaimer in the DOM.
 *
 * @param {company} spec.company - .
 * @param {agency} spec.agency - .
 * @param {period} spec.period - .
 */
export default class ReportDisclaimerWidget extends Widget {
	constructor({ company, agency, period }) {
		super(...arguments);

		this._company = company;
		this._agency = agency;
		this._period = period;
		this._date = new Date();
	}

	renderContentOn(html) {
		if (!optionsBag.fromId("disclaimer").isActive()) {
			return;
		}

		const disclaimer = this._company.getReportDisclaimer();
		const templateVariables = this._reportDisclaimerTemplateVariables();

		html.div(
			{
				klass: "report-disclaimer",
				"data-test": "report-disclaimer",
			},
			html.h2(disclaimer.expandHeader(templateVariables)),
			disclaimer
				.getContentAsParagraphs(templateVariables)
				.map((p) => html.p(p)),
			html.div(
				{ klass: "disclaimer_footer" },
				disclaimer
					.getFooterAsParagraphs(templateVariables)
					.map((p) => html.p(p)),
			),
		);
	}

	setDate(date) {
		this._date = date;
	}

	_reportDisclaimerTemplateVariables() {
		return ReportDisclaimer.buildTemplateVariables({
			agency: this._agency,
			company: this._company,
			currentPeriod: this._period,
			date: this._date,
		});
	}
}
